/*
 * The menu object can be a:
 * - header
 * - divider
 * - item
 * If is header in the appDrawer will be shown only if there are items with the same group as the name of the header.
 * If is divider in the appDrawer will be shown only if there are items with the same group (similarly to the header).
 * If is an item, it can have the following properties:
 * - title: the title of the item ( it is used to check permissions so it must be equal to the last part of the webservice name. Example: 'user' for 'LIST_USER' )
 * - group: the group of the item, used to group items in the appDrawer
 * - name: the name of the route to navigate to
 * - icon: the icon of the item
 * There are some special properties:
 * - requireRole: if true, the item will be shown only if the user has a role that has the permission to access the item
 *                and permission will be checked in the mixin can() method using the item's title
 * - admin: if true, the item will be shown only if the user is an admin (admin is more powerful than requireRole)
 */
const Menu = [
  { header: 'apps' },
  {
    title: 'dashboard',
    group: 'apps',
    icon: 'dashboard',
    name: 'dashboard',
  },
  {
    title: 'control-panel',
    group: 'config',
    name: 'control-panel',
    icon: 'settings',
    admin: true,
  },
  {
    title: 'match',
    group: 'apps',
    icon: 'forum',
    name: 'matches',
    requireRole: true,
  },
  {
    title: 'tournament',
    group: 'apps',
    icon: 'poll',
    name: 'tournaments',
    requireRole: true,
  },
  {
    title: 'training',
    group: 'apps',
    icon: 'forum',
    name: 'trainings',
    requireRole: true,
  },
  {
    title: 'notification',
    group: 'apps',
    icon: 'notifications',
    name: 'notifications',
  },
  { divider: true, group: 'management' },
  { header: 'management' },
  {
    title: 'entity',
    group: 'management',
    name: 'entities',
    icon: 'location_city',
    requireRole: true,
  },
  {
    title: 'team',
    group: 'management',
    name: 'teams',
    icon: 'group',
    requireRole: true,
  },
  /* {
    title: 'player',
    group: 'management',
    name: 'players',
    icon: 'sports_soccer',
    requireRole: true,
  },
  {
    title: 'referee',
    group: 'management',
    name: 'referees',
    icon: 'sports_soccer',
    requireRole: true,
  }, */
  {
    title: 'stadium',
    group: 'management',
    name: 'stadiums',
    icon: 'location_city',
    admin: true,
  },
  {
    title: 'user',
    group: 'management',
    icon: 'group',
    name: 'users',
    requireRole: true,
  },
  {
    title: 'subscription',
    group: 'management',
    name: 'subscriptions',
    icon: 'post_add',
    requireRole: true,
  },
  { divider: true, admin: true, group: 'config' },
  { header: 'config', admin: true },
  {
    title: 'role',
    group: 'config',
    name: 'roles',
    icon: 'settings',
    admin: true,
  },
  {
    title: 'camera',
    group: 'management',
    name: 'cameras',
    icon: 'camera',
    admin: true,
  },
  {
    title: 'rbpi',
    group: 'management',
    name: 'raspberry-pi',
    icon: 'settings_system_daydream',
    admin: true,
  },
  {
    title: 'typeSubscription',
    group: 'config',
    name: 'typeSubscription',
    icon: 'post_add',
    admin: true,
  },
  {
    title: 'typeEvent',
    group: 'config',
    name: 'typeEvents',
    icon: 'bookmarks',
    admin: true,
  },
  {
    title: 'category',
    group: 'management',
    name: 'categories',
    icon: 'library_books',
    admin: true,
  },
  {
    title: 'country',
    group: 'config',
    name: 'countries',
    icon: 'location_on',
    admin: true,
  },
  {
    title: 'region',
    group: 'config',
    name: 'regions',
    icon: 'location_on',
    admin: true,
  },
  {
    title: 'province',
    group: 'config',
    name: 'provinces',
    icon: 'location_on',
    admin: true,
  },
  {
    title: 'town',
    group: 'config',
    name: 'towns',
    icon: 'location_on',
    admin: true,
  },
  {
    title: 'language',
    group: 'management',
    name: 'languages',
    icon: 'language',
    admin: true,
  },
]
// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase()
      let textB = y.title.toUpperCase()
      return textA < textB ? -1 : textA > textB ? 1 : 0
    })
  }
})

export default Menu
